<template>
  <div
    v-if="extensionObject"
    class="flex items-center justify-center rounded"
    :style="'color:' + extension.color"
    :class="extension.name === 'Folder' ? sizeFolder : 'bg-white shadow ' + sizeClass"
  >
    <div class="relative">
      <font-awesome-icon :icon="extension.icon" />
      <span
        v-if="suffix === 'new'"
        class="flex items-center justify-center absolute rounded-full bg-gray-100 text-gray-900 opacity-70 -right-4px"
        :class="[suffixSizeWidth, suffixSizeHeight, suffixTextSize, suffixVerticalPosition]"
      >
        <font-awesome-icon :icon="['fas', 'plus']" />
      </span>
      <span
        v-else-if="extensionObject.suffixIcon"
        class="flex items-center justify-center absolute rounded-full bg-gray-100 text-gray-900 opacity-70 -right-4px"
        :class="[suffixSizeWidth, suffixSizeHeight, suffixTextSize, suffixVerticalPosition]"
      >
        <font-awesome-icon :icon="['fas', extensionObject.suffixIcon]" />
      </span>

      <span
        v-else-if="extensionObject.typeIcon"
        class="flex items-center justify-center text-gray-700 absolute"
        style="top: 0; padding: 10px"
        :style="sizeClass === 'text-xl' ? 'padding-top: 10px;' : 'padding-top: 12px'"
      >
        <font-awesome-icon :icon="['fas', extensionObject.typeIcon]" class="w-1/2" />
      </span>
    </div>
  </div>
  <div v-else class="flex items-center justify-center rounded bg-white shadow" :class="sizeClass">
    <div class="relative">
      <font-awesome-icon :icon="['far', 'file']" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentAvatar",
  props: {
    extensionObject: {
      type: Object,
      required: false
    },
    sizeClass: {
      type: String,
      required: false
    },
    suffix: {
      type: String,
      required: false
    }
  },
  computed: {
    extension() {
      return this.extensionObject;
    },

    sizeFolder() {
      switch (this.sizeClass) {
        case "text-l":
          return "text-2xl";

        case "text-xl":
          return "text-3xl";

        case "text-2xl":
          return "text-4xl";

        case "text-3xl":
          return "text-5xl";

        case "text-4xl":
          return "text-6xl";

        default:
          return "text-2xl";
      }
    },

    suffixSizeWidth() {
      switch (this.sizeClass) {
        case "text-l":
          return "w-3";

        case "text-xl":
          return "w-4";

        case "text-2xl":
          return "w-5";

        case "text-3xl":
          return "w-3";

        case "text-4xl":
          return "w-7";

        default:
          return "w-3";
      }
    },

    suffixSizeHeight() {
      switch (this.sizeClass) {
        case "text-l":
          return "h-3";

        case "text-xl":
          return "h-4";

        case "text-2xl":
          return "h-5";

        case "text-3xl":
          return "h-3";

        case "text-4xl":
          return "h-7";

        default:
          return "h-3";
      }
    },

    suffixTextSize() {
      switch (this.sizeClass) {
        case "text-l":
          return "text-7";

        case "text-xl":
          return "text-7";

        case "text-2xl":
          return "text-10";

        case "text-3xl":
          return "text-7";

        case "text-4xl":
          return "text-13";

        default:
          return "text-7";
      }
    },
    suffixVerticalPosition() {
      switch (this.sizeClass) {
        case "text-l":
          return "bottom-6px";

        case "text-xl":
          return "bottom-6px";

        case "text-2xl":
          if (this.extension.name === "Folder") {
            return "bottom-10px";
          }
          return "-bottom-2px";

        case "text-3xl":
          return "bottom-6px";

        case "text-4xl":
          return "bottom-14px";

        default:
          return "bottom-6px";
      }
    }
  }
};
</script>
